import { render, staticRenderFns } from "./NavigationDrawerNavPanel.vue?vue&type=template&id=8d4ed502&scoped=true"
import script from "./NavigationDrawerNavPanel.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerNavPanel.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerNavPanel.vue?vue&type=style&index=0&id=8d4ed502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4ed502",
  null
  
)

export default component.exports